import * as React from "react";
import {UIState} from "data/UIState";
import {observer} from "mobx-react";
import {observable} from "mobx";
import {createRef} from "react";
import {ButtonAction} from "../widgets/ButtonAction";

/**
 * This step will be deprecated when the custom scheduling system has been implemented
 */
@observer
export default class Step3BWebinar extends React.Component<Props> {
  @observable scheduled = false;

  schedule = () => {
    this.scheduled = true;
  }
  h1Ref;

  constructor(props:Props) {
    super(props);
    this.h1Ref = createRef();
  }

  render() {
    return (
      <>
        <div className="signup-head">
          <h1 ref={this.h1Ref} tabIndex={0}>{UIState.settings.WEIGH_IN_HEADLINE}</h1>
        </div>

        { !this.scheduled ?
          <div className={`schedule`}>
            <div className="form-element">
              <div className="icon-label">
                <i className="icon icon-calendar-filled"/>
                <div>
                  <p className="hint" style={{marginTop:'20px'}}>{UIState.settings.WEIGH_IN_DETAILS}</p>
                </div>
              </div>
              <div style={{textAlign:'center'}}>
                <a href={UIState.settings.WEIGH_IN_LINK}
                   onClick={this.schedule}
                   target="_blank"
                   className="bordered-button"><i className="icon icon-new-window"/>{UIState.settings.WEIGH_IN_BUTTON_LABEL?UIState.settings.WEIGH_IN_BUTTON_LABEL:'Register'}</a>
              </div>
            </div>
          </div>

          :

          <div className="form-element">
            <div className="icon-label">
              <i className="icon icon-checkmark success"/>
              <div>
                <label>Thanks for using the scheduling tool</label>
                  <p>Not sure if you registered?&nbsp;
                    <a href={UIState.settings.WEIGH_IN_LINK} target="_blank">
                      {UIState.settings.WEIGH_IN_BUTTON_LABEL?UIState.settings.WEIGH_IN_BUTTON_LABEL:'Register'}
                    </a>
                  </p>
              </div>
            </div>
          </div>
        }
        <div className={'form-element tight'}>
          {/*<ButtonAction onClick={this.props.continue} className={"cta-button noselect"}>Continue</ButtonAction>*/}
          <a className="cta-button noselect" onClick={this.props.continue} href="#">Continue</a>
        </div>
      </>
    );
  }
}

interface Props {
  continue:()=>void;
}
